export enum HeaderSectionType {
  Standalone = 'Standalone',
  Compose = 'Compose',
}
